import { motion } from 'framer-motion'
import styled from 'styled-components'

import { P } from '@/@bothrs-ui/web/components/typography/Body'

const StErrorContainer = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-bottom: 0px;
`

const StErrorText = styled(P)`
  padding: 0px ${({ theme }) => theme.UI.SpacingPx.Space8};
`

const AnimatedErrorContainer = motion(StErrorContainer)

export { AnimatedErrorContainer, StErrorContainer, StErrorText }
